import request from '../../utils/request';
import options from './options';

const urlPath = (url, path) => `${url}${path}`;

export const getCalculatorsSoilComposition = filter => request.get({
    url: urlPath(options.apiUrl, filter)
});

export const getCalculatorsSoilCompositionItem = id => request.get({
    url: urlPath(options.apiUrl, `${id}/`)
});